import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container mx-auto p-6">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>

      <p className="mb-6">
        At <strong>Daga Gems</strong>, we understand the importance of your
        privacy and the information you share with us. Your trust is valuable,
        and we are committed to safeguarding your personal data. This Privacy
        Policy outlines how we collect, use, and protect your information.
      </p>

      <ol className="list-decimal list-inside space-y-6">

        <li>
          <h2 className="text-xl font-semibold mb-2">
            Voluntary Information
          </h2>
          <p>
            All information provided by you, including sensitive personal data,
            is voluntary. You may withdraw your consent at any time. However,
            withdrawal will not have a retroactive effect. You can update or
            modify your data anytime.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">Data Retention</h2>
          <p>
            We retain a copy of your original information even after updates for
            record-keeping and service improvement purposes.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">
            Information We Collect
          </h2>
          <p>
            We automatically collect information such as referring URLs,
            destination URLs, IP address, browser details, operating system,
            email patterns, and ISP details. This helps us analyze trends and
            improve services. Temporary cookies are used for technical and
            research purposes.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">
            Third-Party Cookies
          </h2>
          <p>
            Authorized third parties may use cookies to enhance services and
            deliver ads. These cookies do not store sensitive personal
            information.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">
            Telephone Call Records
          </h2>
          <p>
            We may record calls for inquiries, orders, service improvements, and
            quality assurance.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">
            Advertisement Services
          </h2>
          <p>
            We allow third-party advertisers to serve ads. While we may show
            targeted ads, we do not use your personal data for ad targeting.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">
            Equipment and Security
          </h2>
          <p>
            We are not liable for any damage or viruses affecting your device
            while using our website. If dissatisfied, you may discontinue using
            our services.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">
            Website Disclaimer
          </h2>
          <p>
            This policy applies only to Daga Gems services. We are not
            responsible for third-party websites and recommend reviewing their
            policies.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">
            User Communication and Personal Details
          </h2>
          <p>
            We are not responsible for misuse of personal data shared publicly
            or with other users on our platform.
          </p>
        </li>

        <li>
          <h2 className="text-xl font-semibold mb-2">Data Sharing</h2>
          <p>
            We do not share your personal data without consent, except when
            required by law. Non-sensitive data may be shared with trusted
            partners for business growth. Sensitive data like passwords and
            financial details are never shared.
          </p>
        </li>

      </ol>
    </div>
  );
};

export default PrivacyPolicy;